export default __webpack_public_path__ + "static/media/girl.73c9ebca.svg";